import { ISearchDisplayFieldDTO, ISearchResultDTO } from 'business/models/Models';
import { IDropDownList } from 'components/customComponents/CommonComponents/RMDropDownList';
import { DisplayMode } from 'components/Experiment/constants';
import { IOption } from 'components/input/selectInput';

export type SearchHeaderButtonParams = {
  displayFields: ISearchDisplayFieldDTO[];
  isResultTab: boolean;
  primarySelectedSearchRow: { [key: string]: any };
  selectedTargetName: ESearchTargetNames;
  reportsList: IDropDownList[];
  isReportsDisabled: boolean;
  performSearch: (p1, p2) => Promise<ISearchResultDTO> | false;
  setIsLoading: (flag: boolean) => void;
  chartInstance: any;
  isChartTab: boolean;
  selectedChartName: string;
};

export enum ESearchTargetNames {
  Project = 'Project',
  Experiment = 'Experiment',
  ProteinFormulation = 'Protein Formulation',
  ExperimentPlate = 'Experiment Plate',
  Well = 'Well',
  WellDrop = 'Well Drop',
  WellIngredient = 'Well Ingredient',
  RegionAnnotation = 'Region Annotation',
  Screen = 'Screen',
  ScreenHits = 'Screen Hits',
  Seed = 'Seed',
  DropsByScore = 'Drops by Score',
  Xtals = 'Xtals V4',
}

export enum ESearchPathFilters {
  All = 'All',
  Selected = 'Selected',
}

export const searchPathFilterOptions: IOption[] = [
  { title: ESearchPathFilters.All, value: ESearchPathFilters.All },
  { title: ESearchPathFilters.Selected, value: ESearchPathFilters.Selected },
];

export const SnfCanvasRoutes = [
  DisplayMode.DESIGN,
  DisplayMode.IMAGE,
  DisplayMode.WELLINGREDIENT,
  DisplayMode.SCORE,
];

export enum EScoreGroupTypes {
  All = 'All Scores',
  Auto = 'Auto Scores',
  Manual = 'Manual Scores',
}

export const HitScoreName = 'Positive Hit';
export const SNF_COMPARE_VIEW_COL_GAP_FACTOR = 4;
export const CrystalSearchTarget = 'Xtals';
